import { GridStatsCard } from '@/components/shared/GridStatsCard';
import useCurrency from '@/hooks/query/useCurrency';
import useWalletAllNFTs from '@/hooks/query/useWalletAllNFTs';
import useWalletCryptos from '@/hooks/query/useWalletCrypto';
import { USDDollarFormatter } from '@/utils/formatter';
import 'rc-dropdown/assets/index.css';

const PortfolioStats: React.FC = () => {
  const { data: walletValuation, isLoading: walletValuationLoading } = useWalletAllNFTs({ cachedData: true });
  const { data: walletCrypto, isLoading: walletCryptoLoading } = useWalletCryptos();
  const nettyWorth = (Number(walletCrypto?.walletCryptoBalance) || 0) + (walletValuation || 0);
  const { isLoading: currencyLoading } = useCurrency();

  const stats = [
    {
      name: 'NettyWorth',
      value: currencyLoading || walletCryptoLoading || walletValuationLoading ? 'loading' : USDDollarFormatter(nettyWorth),
      largeFontSizeValue: true,
    },
    {
      name: 'Crypto Value',
      value: walletCryptoLoading ? 'loading' : walletCrypto ? USDDollarFormatter(walletCrypto.walletCryptoBalance) : '',
    },
    {
      name: 'NFT Value',
      value: walletValuationLoading ? 'loading' : walletValuation !== undefined ? USDDollarFormatter(walletValuation) : '',
    },
  ];

  return (
    <div className='flex flex-col gap-7 lg:flex-row justify-between items-center pb-7 lg:p-7 pt-0 lg:pt-0 max-lg:px-6 border-b'>
      <div className='grid grid-cols-3 w-max'>
        {stats.map(({ name, value }) => (
          <GridStatsCard key={name} title={name} value={value} price={true} className='min-h-[109px]' />
        ))}
      </div>
    </div>
  );
};

export default PortfolioStats;
